type Step07EvalBaseDataLike = {
  baseData?: {
    performExecYn?: boolean | string;
    abilityExecYn?: boolean | string;
  };
};

type Step07EvalGroupLike = {
  abilityEvalYn?: boolean | string;
  performEvalYn?: boolean | string;
  resultEvalYn?: boolean | string;
  processEvalYn?: boolean | string;
};

type Step07PerformTypeLike = {
  resultEvalYn?: boolean | string;
  processEvalYn?: boolean | string;
};

const isEnabledYn = (value: boolean | string | null | undefined) => value === true || String(value ?? '').trim() === 'Y';

/** Step4 성과평가 시행: 결과/과정 중 하나라도 ON이면 사용(performEvalYn 동기화와 동일) */
const isGroupPerformEvalEnabled = (evalGroup?: Step07EvalGroupLike | null) =>
  isEnabledYn(evalGroup?.performEvalYn) || isEnabledYn(evalGroup?.resultEvalYn) || isEnabledYn(evalGroup?.processEvalYn);

/**
 * Step07 성과/역량 비율 열 표시.
 * Step01 시행 여부 AND (평가군이 있으면) Step4 해당 평가군 시행 여부.
 * evalGroup이 없으면 Step01만 본다.
 */
export const getStep07RatioColumnFlags = (
  evalBaseData: Step07EvalBaseDataLike,
  evalGroup?: Step07EvalGroupLike | null,
) => {
  const base = evalBaseData?.baseData || {};
  const step01Perf = isEnabledYn(base.performExecYn);
  const step01Cmpt = isEnabledYn(base.abilityExecYn);
  if (!evalGroup) {
    return {
      perf: step01Perf,
      cmpt: step01Cmpt,
    };
  }
  return {
    perf: step01Perf && isGroupPerformEvalEnabled(evalGroup),
    cmpt: step01Cmpt && isEnabledYn(evalGroup.abilityEvalYn),
  };
};

export const getStep07PerformTypeFlags = (source: Step07PerformTypeLike | null | undefined) => ({
  result: isEnabledYn(source?.resultEvalYn),
  process: isEnabledYn(source?.processEvalYn),
});
